module.exports = __webpack_public_path__ + "img/logo.f9dde36b.png";